import { defaultApiUrl } from "../api/util";

interface IDataUdtraek {
  navn: string;
  beskrivelse: string;
  link: string;
  type: "default" | "kursuskategori" | "dateinterval";
}
export const DATAUDTRAEK: IDataUdtraek[] = [
  {
    navn: "Nyt om Navne",
    beskrivelse:
      'Information til "Nyt om navne" på advokatsamfundet.dk for den valgte periode.',
    link: defaultApiUrl + "udtraek/navnenyt",
    type: "dateinterval",
  },
  {
    navn: "Censorliste",
    beskrivelse:
      "Liste med censorer ved retssagsprøven. På listen fremgår de allerede bookede retssagsprøver i den valgte periode.",
    link: defaultApiUrl + "udtraek/censorliste",
    type: "dateinterval",
  },
  {
    navn: "Tilsynsliste firmaer",
    beskrivelse:
      "Liste med information om seneste tilsyn hos advokatvirksomheder.",
    link: defaultApiUrl + "udtraek/tilsynslisteFirmaerMedTilsyn",
    type: "default",
  },
  {
    navn: "Tilsynsliste advokater",
    beskrivelse: "Liste med information om seneste tilsyn hos advokater.",
    link: defaultApiUrl + "udtraek/tilsynslisteAdvokaterMedTilsyn",
    type: "default",
  },
  {
    navn: "Advokater uden gældende forsikring",
    beskrivelse:
      "Liste med udøvende advokater, som ikke har registreret ansvarsforsikring pr. dags dato.",
    link:
      defaultApiUrl + "udtraek/tilsynslisteAdvokaterUdenGaeldendeForsikring",
    type: "default",
  },
  {
    navn: "Medlemsliste for KAF",
    beskrivelse: "Liste med medlemmer af Københavns Advokatforening.",
    link: defaultApiUrl + "udtraek/kafmedlemsliste",
    type: "dateinterval",
  },
  {
    navn: "Alle sanktioner",
    beskrivelse: "Liste over alle sanktioner.",
    link: defaultApiUrl + "udtraek/sanktionerliste",
    type: "default",
  },
  {
    navn: "Antal sanktioner per person/firma",
    beskrivelse: "Liste med antal sanktioner per person/firma.",
    link: defaultApiUrl + "udtraek/antalsanktionerliste",
    type: "default",
  },
  {
    navn: "Kursuskategori",
    beskrivelse:
      "Liste med antal tilmeldte kursister for fremtidige FMU-kurser for den valgte kursustype.",
    link: "",
    type: "kursuskategori",
  },
  {
    navn: "Fejlliste",
    beskrivelse:
      "Liste med registreringer i Aika, som ikke overholder logiske regler for sammenhæng i data.",
    link: defaultApiUrl + "validering/download",
    type: "default",
  },
  {
    navn: "Revision - KAF medlemskaber",
    beskrivelse:
      "Liste over ind- og udmeldelser af KAF for den valgte periode.",
    link: defaultApiUrl + "udtraek/kafmedlemskabAktivitetsListe",
    type: "dateinterval",
  },
  {
    navn: "Revision - Personbeskikkelser",
    beskrivelse: "Liste over beskikkelsesstatusser for den valgte periode.",
    link: defaultApiUrl + "udtraek/personbeskikkelseliste",
    type: "dateinterval",
  },
  {
    navn: "Revision - Kursuspersoner",
    beskrivelse: "Liste over kursusaktiviteter for den valgte periode.",
    link: defaultApiUrl + "udtraek/kursuspersonliste",
    type: "dateinterval",
  },
  {
    navn: "Revision - Afdøde ",
    beskrivelse: "Liste over afdøde personer for den valgte periode.",
    link: defaultApiUrl + "udtraek/doedepersonerliste",
    type: "dateinterval",
  },
  {
    navn: "Retssagsprøver",
    beskrivelse: "Liste over retssagsprøver for den valgte periode.",
    link: defaultApiUrl + "udtraek/retssagsproever",
    type: "dateinterval",
  },
];
